import { Injectable } from '@angular/core';
import { LoggerEvent, LoggerProvider } from '../../providers/logger/logger';
import { UtilsProvider } from '../../providers/myria/utils-provider';
import { TranslateService } from '@ngx-translate/core';
import { ADDITIONAL_DETAILS_FIELDS_ID, COUNTRY_SETTINGS, COUNTRY_SETTINGS_ENABLE_VALUE, REGISTRATION_FIELDS_ID } from '../../providers/myria/app-variables';
import { APP_CONFIG } from '../../environment';
import { OrderProvider } from '../../providers/order/order';

@Injectable()
export class AdditionalDetailsProvider {

    constructor(
        private translateService: TranslateService,
        private utilsProvider: UtilsProvider,
        private translate: TranslateService,
        private orderProvider: OrderProvider,

    ) {}

    customerAdditionalFields: any = {};


    public async getAdditionalFieldSteps(customerFields, recipientFields) {
        let hasCLIdentityField: boolean = false;
        this.customerAdditionalFields = {};

        if (!customerFields)
          customerFields = [];
        if (!recipientFields)
          recipientFields = [];
        let addressFields = [];
        if (customerFields.length > 0) {
          addressFields = customerFields.filter((field) => field.category === 'Address');
          customerFields = customerFields.filter((field) => { return field.category !== 'Address' });

          const addressIdentifiers = ['address', 'faddress'];
    
          const address = addressFields.find((field) =>
            addressIdentifiers.includes(field.id) ||
            (field.fieldModel && field.fieldModel.FieldName && addressIdentifiers.includes(field.fieldModel.FieldName.toLowerCase()))
          );
          if (address) {
            const loqateSetting = await this.utilsProvider.hasCountrySettingByPromise(APP_CONFIG.region.regionId, COUNTRY_SETTINGS.LOQATE_ADDRESS_ENABLE);
            if (loqateSetting == COUNTRY_SETTINGS_ENABLE_VALUE)  
              address.type = 'loqate';
          }
    
          const country = addressFields.find((field) =>
            (field && field.fieldModel && field.fieldModel.FieldName &&
            field.fieldModel.FieldName.toLowerCase() === 'country') ||
            (field && field.id === 'country'));
    
          // const country = addressFields.find((field) => field.id === 'country')
          if (country) {
            country.disabled = true;
            country.type = 'Country';
          }

          hasCLIdentityField = this.hasCLIdentityField(customerFields);
        }

        const steps = [];        

        // Additional details grouping
        let categorizedDetails = {};
        const isGroupingEnabled = await this.isGroupingEnabled(customerFields, recipientFields);
        // const isGroupingEnabled = "";


        if (isGroupingEnabled) {
          // Re-add addressFields to customerFields
          customerFields = [...customerFields, ...addressFields];
          
          // First consolidate all fields to a single object categorizedDetails
          customerFields.forEach(field => {


            const { screenCategory, screenId } = field;
    
            if (!categorizedDetails[screenCategory]) {
              categorizedDetails[screenCategory] = {};
            }
    
            if (!categorizedDetails[screenCategory][screenId]) {
              categorizedDetails[screenCategory][screenId] = [];
            }
    
            categorizedDetails[screenCategory][screenId].push(field);
          });
    
          recipientFields.forEach(field => {
            const { screenCategory, screenId } = field;

            field.clientType = 'Recipient'; // setting this type to be able to filter later
    
            if (!categorizedDetails[screenCategory]) {
              categorizedDetails[screenCategory] = {};
            }
    
            if (!categorizedDetails[screenCategory][screenId]) {
              categorizedDetails[screenCategory][screenId] = [];
            }

    
            categorizedDetails[screenCategory][screenId].push(field);
          });

          // Remove isValid fields from categorizedDetails
          Object.keys(categorizedDetails).forEach(category => {
            Object.keys(categorizedDetails[category]).forEach(screenId => {
              categorizedDetails[category][screenId] = categorizedDetails[category][screenId].filter(field => {
                if (field.screenCategory === 'ProfileRefresh' || field.reAsk)
                  return true;
                
                const hasValue = field.value !== undefined && field.value !== null && field.value !== '';
                
                if ((field.id === 'incomeCurrency' || field.id === '46605') && hasValue)
                  return true;

                const isOptionList = field.fieldType === 'OptionList' || (field.fieldModel && (field.fieldModel.Type === 'OptionList' || field.fieldModel.Type === 'searchableSelect'));
                
                const isValid = field.isValid && field.value !== "0" && !isOptionList ||
                field.fieldModel && isOptionList && hasValue;
                return !isValid;
              });
              
              // Remove empty screenIds
              if (categorizedDetails[category][screenId].length === 0) {
                delete categorizedDetails[category][screenId];
              }
            });
            
            // Remove empty categories
            if (Object.keys(categorizedDetails[category]).length === 0) {
              delete categorizedDetails[category];
            }
          });

    
          // Process remaining fields by category
          const screenCategoryOrder = ['ProfileRefresh', 'Sender', 'Recipient', 'Transfer'];
          const sortedCategories = Object.keys(categorizedDetails)
            .sort((a, b) => screenCategoryOrder.indexOf(a) - screenCategoryOrder.indexOf(b));
    
          sortedCategories.forEach(category => {
            // Get unique screenId values and their corresponding screenIdOrder values
            const screenIdToOrderMap = {};
            
            Object.keys(categorizedDetails[category]).forEach(screenId => {
              // Use the screenIdOrder from the first field in each screen
              // (assuming all fields in the same screen have the same screenIdOrder)
              const firstField = categorizedDetails[category][screenId][0];
              screenIdToOrderMap[screenId] = firstField.screenIdOrder || Number.MAX_SAFE_INTEGER;
            });
            
            // Sort screenIds by their screenIdOrder values
            const screenIds = Object.keys(categorizedDetails[category])
              .sort((a, b) => {
                const orderA = screenIdToOrderMap[a];
                const orderB = screenIdToOrderMap[b];
                
                // Sort by screenIdOrder (lower values first)
                if (orderA !== orderB) {
                  return orderA - orderB;
                }
                
                // If screenIdOrder values are the same, sort alphabetically
                return a.localeCompare(b);
              });
    
            screenIds.forEach(screenId => {
              if (screenId == "null") {
                return;
              }
              
              // Sort fields within each screenId based on screenIdOrder if available
              const fieldsWithOrder = categorizedDetails[category][screenId].sort((a, b) => {
                // If screenIdOrder is present in both fields, sort by it
                if (a.screenIdOrder !== null && b.screenIdOrder !== null) {
                  return a.screenIdOrder - b.screenIdOrder;
                }
                // If screenIdOrder is missing in one field, prioritize the one with screenIdOrder
                if (a.screenIdOrder !== null) return -1;
                if (b.screenIdOrder !== null) return 1;
                return 0;
              });
              
              steps.push({
                screenCategory: category,
                screenType: fieldsWithOrder[0].screenType,
                screenId: screenId,
                showCheckBox: hasCLIdentityField && screenId === 'CustomerOtherDetails',
                isAddress: fieldsWithOrder[0].category === 'Address',
                // customerFields: fieldsWithOrder,
                checkBoxText: 'page.sendMoneyAdditionalDetailsPage.confirmDetailsBody',
                customerFields: fieldsWithOrder[0].clientType !== 'Recipient' ? fieldsWithOrder : null,
                recipientFields: fieldsWithOrder[0].clientType === 'Recipient' ? fieldsWithOrder : null,
                headerTitle: this.translate.instant(`${this.mapTitle(screenId)}`),
                additionalTitle: this.mapContent(screenId) ? this.translate.instant(`${this.mapContent(screenId)}`, {recipientName: this.orderProvider.order.recipient.firstName}) : null,
              });
            });
          });
        } else {
          if (customerFields && customerFields.length > 0) {
            steps.push({customerFields: customerFields,
              showCheckBox: hasCLIdentityField,
              checkBoxText: 'page.sendMoneyAdditionalDetailsPage.confirmDetailsBody',
              ...(hasCLIdentityField && { additionalTitle: this.translate.instant('page.sendMoneyAdditionalDetailsPage.needDetailsBody')})
            });
          }
    
          if (addressFields.length > 0) {
            steps.push({ customerFields: addressFields, isAddress: true,
              headerTitle: this.translate.instant('page.sendMoneyAdditionalDetailsPage.confirmAddressTitle')});
          }

          if (recipientFields && recipientFields.length > 0) {
            steps.push({ recipientFields: recipientFields,
              headerTitle: this.translate.instant('page.sendMoneyAdditionalDetailsPage.recipientHeader'),
              additionalTitle: this.translate.instant('page.sendMoneyAdditionalDetailsPage.additionalDetailsRecipientHeader')
            });
          }
        }

        return steps;
      }
    
    mapTitle(screenId: string): string {
        // if (UtilsProvider.capitalizeFirstLetter(screenId) === "RefreshCustomerProfile") {
        //     return "ProfileRefresh.personalDetails.title";
        // }
        // if (UtilsProvider.capitalizeFirstLetter(screenId) === "RefreshCustomerAddress") {
        //     return "ProfileRefresh.address.title";
        // }
        let key = UtilsProvider.capitalizeFirstLetter(screenId) + ".title";
        
        const translated = this.translateService.instant(key);
        
        if (this.isTranslationMissing(translated, key)) {
            return "CustomerOtherDetails.title";
        }
        
        return key;
    }
    
    isTranslationMissing(translatedValue: string, translationKey: string): boolean {
        const isMissing = translatedValue.trim().endsWith('NOT FOUND') ||
            translatedValue === translationKey;
            
        if (isMissing) {
            LoggerProvider.info(LoggerEvent.GeneralException, "additional details content is missing - returning default key",{
                key: translationKey,
                value: translatedValue
            });
        }
        
        return isMissing;
    }
    
    mapContent(screenId: string): string {
        if (UtilsProvider.capitalizeFirstLetter(screenId) === "RefreshCustomerProfile" || UtilsProvider.capitalizeFirstLetter(screenId) === "RefreshCustomerAddress") {
            return "";
        }
        let key = UtilsProvider.capitalizeFirstLetter(screenId) + ".content";
        
        const translated = this.translateService.instant(key);
        
        if (this.isTranslationMissing(translated, key)) {
            return "CustomerOtherDetails.content";
        }
        return key;
    }

    async isGroupingEnabled(customerFields = [], recipientFields = []): Promise<boolean> {
       // Additional details grouping
        let isNewAdditionalFieldFlow = false;
        let categorizedDetails = {};
        if (recipientFields && recipientFields.length > 0) {
          isNewAdditionalFieldFlow = recipientFields[0].screenId != null && recipientFields[0].screenId != undefined;
        }
        else if (customerFields && customerFields.length > 0) {
          isNewAdditionalFieldFlow = customerFields[0].screenId != null && customerFields[0].screenId != undefined;
        }
        const isGroupingEnabled = await this.utilsProvider.hasCountrySettingByPromise(APP_CONFIG.region.regionId, COUNTRY_SETTINGS.DIGITAL_SEND_MONEY_FIELDS_SCREEN_GROUPING_ENABLED);
        return COUNTRY_SETTINGS_ENABLE_VALUE == isGroupingEnabled && isNewAdditionalFieldFlow;
    }

  private hasCLIdentityField(customerFields) {
    const validIds = [REGISTRATION_FIELDS_ID.ID_NUMBER, ADDITIONAL_DETAILS_FIELDS_ID.ID_DOCUMENT_NUMBER];
    const identityField = customerFields.find(field => validIds.includes(field.id));
    const isCLIdentityField = APP_CONFIG.region.defaultCountryFrom === 'CL' && identityField !== null && identityField !== undefined;

    return isCLIdentityField;
  }
}

export enum FieldId {
    countryOfBirth = "senderCOB",
    nationality = "senderNationality",
    countryOfResidence = "senderCOR",   
    sourceOfFunds = "transferSourceOfFunds",
    occupationId = "senderOccupation",
    transferReason = "transferPurpose",
}

export const NON_PROFILE_ADDITIONAL_FIELD_IDS = ['transferReason', 'sourceOfFunds', 'address', 'postalCode', 'city', 'unitNumber', 'state', 'country'];



// WEBPACK FOOTER //
// ./src/providers/send-flow/additional-details.ts